declare global {
  interface Window {
    onReCaptchaScriptLoaded?: () => void;
  }
}

let scriptLoadedPromise: Promise<void> | null = null;

export const loadRecaptchaScript = (): Promise<void> => {
  // Check if the script is already loaded
  // This is only added as a precaution as the script should only be loaded once
  // and could be loaded by a different component/code
  if (typeof window === "undefined") {
    return Promise.reject(new Error("Not needed in ssr environment"));
  }
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  if (window.grecaptcha) {
    return Promise.resolve();
  }

  // If the script is currently being loaded, return the existing promise
  if (scriptLoadedPromise != null) {
    return scriptLoadedPromise;
  }

  // Create a promise to load the script
  scriptLoadedPromise = new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.src = "https://www.recaptcha.net/recaptcha/api.js?render=explicit&onload=onReCaptchaScriptLoaded";
    script.async = true;
    script.defer = true;
    script.onerror = () => reject(new Error(`Failed to load reCAPTCHA script`));

    // Define the global callback that resolves the promise
    window.onReCaptchaScriptLoaded = () => {
      resolve();
    };

    document.head.appendChild(script);
  });

  return scriptLoadedPromise;
};
